module.exports = __webpack_public_path__ + "static/media/icon-other.a1594c58.svg";